module.exports = __webpack_public_path__ + "img/4bc-1116.730f7a08.png";